import React, { useState } from "react";
import { FaHeart } from "react-icons/fa"; // heart icon

const WishlistCard = ({
  productImage,
  productName,
  productBy,
  price,
  onMoveToCart,
}) => {
  const [isFavorite, setIsFavorite] = useState(true); // default true for wishlist

  return (
    <div className="wishlist-card">
      {/* Product Image + Favorite */}
      <div className="wishlist-card-image">
        <img src={productImage} alt={productName} />
        <button
          className={`wishlist-favorite-btn ${isFavorite ? "active" : ""}`}
          onClick={() => setIsFavorite(!isFavorite)}
        >
          <FaHeart />
        </button>
      </div>

      {/* Details */}
      <div className="wishlist-card-details">
        <h3 className="wishlist-title">{productName}</h3>
        <p className="wishlist-by">
          {productBy} <span className="wishlist-verified">✔</span>
        </p>
        <p className="wishlist-price">{price} USD</p>
      </div>

      {/* Button */}
      <button className="wishlist-move-to-cart" onClick={onMoveToCart}>
        Move to Cart
      </button>
    </div>
  );
};

export default WishlistCard;
